import {
  Alert,
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  Collapse,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Input,
  InputLabel,
  LinearProgress,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Snackbar,
  Stack,
  TextField,
  Typography,
  Grid,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import React, { useEffect, useMemo, useState } from "react";
import {
  BANK_STATUS,
  CONFIGURATION_CONSTANTS,
  FILE_SUFFIX,
  PARTY_TYPE,
  UPLOAD_FILE_CONTENT_NAME,
  UPLOAD_FILE_CONTENT_TYPE,
  UPLOAD_FILE_PURPOSE_TYPE,
  cookieNames,
  getExtensionFromMimeType,
} from "../../shared/constants/constants";
import { getSessionVariable, getUserContext } from "../../shared/utils/utils";
import {
  createBankDetails,
  createPartyPref,
  createPartyTags,
  getBankDetails,
  getPartyById,
  getPartyPref,
  getPartyTags,
  updateBankDetails,
  updatePartyDetails,
  updatePartyPref,
  deactivateTag,
} from "../../store/api/configuration";
import store, { RootState } from "../../store/store";
import { validateConfiguration } from "../../shared/utils/validator";
import VisuallyHiddenInput from "../../shared/components/hiddenInput/hiddenInput";
import { CreateNewFolder, Delete } from "@mui/icons-material";
import { uploadFileParty } from "../../store/api/fileUpload";
import { createPartyContent, getPartyContent } from "../../store/api/content";
import CustomSpinner from "../../shared/components/customSpinner/customSpinner";
import { createContentService } from "../../shared/models/createContent";
import { sendOtpAPI, verifyOtpAPI } from "../../store/api/common";
import OtpInput from "react-otp-input";
import { getPartyContactDetails } from "../../store/api/order";
import { useSelector } from "react-redux";

const Configuration = () => {
  const userContext: any = getUserContext();
  const storeParentPartyOrg = useSelector(
    (state: RootState) => state.party.parentOrg
  );
  const [pageState, setPageState] = useState<boolean>(true);
  const [openSnack, setOpenSnack] = useState({
    message: "",
    open: false,
    variant: "success",
  });

  const [showStampSaveBtn, setShowStampSaveBtn] = useState<boolean>(true);
  const [otp, setOtp] = useState("");
  const [isValidOtp, setIsValidOtp] = useState<boolean>(true);
  const [phone, setPhone] = useState("");
  const [sequence, setSequence] = useState({
    prefix: "",
    startIndex: "",
    currentIndex: "",
    update: false,
  });

  const handleSnack = (message: string, variant: string) => {
    setOpenSnack({ message: message, open: true, variant: variant });
  };

  const handleCloseSnack = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack({ ...openSnack, open: false });
  };
  const [loading, setIsLoading] = useState<string>("");
  const [stamp, setStamp] = useState<any>(null);
  const [orgLogo, setOrgLogo] = useState<any>(null);
  const [partyIdDetails, setPartyIdDetails] = useState<{
    [index: string]: string;
  }>({
    [CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER]: "",
  });

  const [bankDetails, setBankDetails] = useState<{ [index: string]: string }>({
    [CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_HOLDER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_NUMBER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.BANK_NAME]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.IFSC_CODE]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.C_ACCOUNT_NUMBER]: "",
  });

  const [allBankDetails, setAllBankDetails] = useState<
    { [index: string]: string }[]
  >([]);
  const [partyId, setPartyId] = useState<string>("");
  const [loggedInPartyId, setLoggedInPartyId] = useState<string>("");

  const [stampExists, setStampExists] = useState<boolean>(false);
  const [orgLogoExists, setOrgLogoExists] = useState<boolean>(false);
  const [inputError, setInputError] = useState<{
    mode: "STAMP" | "ORG_LOGO" | "";
    error: string[];
  }>({ mode: "", error: [] });

  const [existsPayment, setExistsPayment] = useState<boolean>(false);
  const [existsTnC, setExistsTnC] = useState<boolean>(false);
  const [existsBankDetails, setExistsBankDetails] = useState<boolean>(false);
  // const [existsPartyDetails, setExistsPartyDetails] = useState<boolean>(false);
  const [existsPrefVendor, setExistsPrefVendor] = useState<boolean>(false);
  const [existsROValue, setExistsROValue] = useState<boolean>(false);
  const [paymentTerm, setPaymentTerm] = useState<string>(
    CONFIGURATION_CONSTANTS.PAYMENT_TERMS_VALUES.OTHER
  );
  const [otherPaymentTerm, setOtherPaymentTerm] = useState<string>("");
  const [tnc, setTnC] = useState<string>("");
  const [sendRFQChoice, setSendRFQChoice] = useState<string>("");
  const [roValue, setROValue] = useState<any>("");
  const [tags, setTags] = useState<any>([]);
  const [tagInput, setTagInput] = useState<string>("");
  const [defaultBid, setDefaultBid] = useState<string>("2");
  const [comm, setComm] = useState<
    { name: string; checked: boolean; id: string; exists: boolean }[]
  >([
    {
      name: "E-Mail",
      checked: false,
      id: CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.EMAIL,
      exists: false,
    },
    {
      name: "WhatsApp",
      checked: false,
      id: CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.WHATSAPP,
      exists: false,
    },
    {
      name: "SMS",
      checked: false,
      id: CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.SMS,
      exists: false,
    },
  ]);

  const paymentTermList = [
    {
      name: "30 Days",
      value: CONFIGURATION_CONSTANTS.PAYMENT_TERMS_VALUES.DAYS30,
    },
    {
      name: "60 Days",
      value: CONFIGURATION_CONSTANTS.PAYMENT_TERMS_VALUES.DAYS60,
    },
    {
      name: "90 Days",
      value: CONFIGURATION_CONSTANTS.PAYMENT_TERMS_VALUES.DAYS90,
    },
    {
      name: "Other",
      value: CONFIGURATION_CONSTANTS.PAYMENT_TERMS_VALUES.OTHER,
    },
  ];

  const [errorItems, setErrorItems] = useState<{ [index: string]: string }>({
    [CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_HOLDER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_NUMBER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.BANK_NAME]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.IFSC_CODE]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.REPEAT_ORDER]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.TAGS]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.PO_CURRENT]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.PO_PREFIX]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.PO_START]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.TnC]: "",
    [CONFIGURATION_CONSTANTS.INPUT_ID.DEFAULT_BID_DATE]: "",
    otherPaymentTerm: "",
  });

  const sendRFQOptions = [
    {
      name: "To All Vendors",
      value: CONFIGURATION_CONSTANTS.SEND_RFQ_VALUES.ALL_VENDORS,
    },
    {
      name: "To Preferred Vendors",
      value: CONFIGURATION_CONSTANTS.SEND_RFQ_VALUES.PREFERRED_VENDORS,
    },
  ];

  const handleChangeROValue = (event: any) => {
    let value = event.target.value;
    const regex = /^[\d.]*$/;
    if (!regex.test(value)) {
      return;
    }
    const num = value.split(".");
    if (num[1] && num[1].length > 2) {
      value = num[0] + "." + num[1].slice(0, 2);
    }
    setROValue(value);
  };

  const handleChangePartyDetails = (event: any) => {
    setPartyIdDetails({
      ...partyIdDetails,
      [event.target.id]: event.target.value,
    });
  };

  const handleChangeBankDetails = (event: any) => {
    setBankDetails({ ...bankDetails, [event.target.id]: event.target.value });
  };

  const handleComm = (id: string) => {
    setComm(
      comm.map((element) => {
        if (element.id === id) {
          return { ...element, checked: !element.checked };
        }
        return element;
      })
    );
  };

  const handleImageChange = (targetImage: any, mode: "STAMP" | "ORG_LOGO") => {
    if (!targetImage) return;
    const allowedFileTypes = ["png", "jpg", "jpeg"];
    const fileType = targetImage?.[0]?.type?.split("/");
    const fileSize = targetImage?.[0]?.size;
    const errorArr = [];
    if (fileSize && fileSize > 5000000) {
      errorArr.push("File Size is greater than allowed limit:::");
      errorArr.push("Current Size: " + fileSize);
    }
    if (
      fileType &&
      (!allowedFileTypes.includes(fileType[1]) || fileType[0] !== "image")
    ) {
      errorArr.push("File Format not Accepted");
    }
    if (errorArr.length === 0) {
      if (mode === "STAMP") {
        setStamp(targetImage[0]);
      }
      if (mode === "ORG_LOGO") {
        setOrgLogo(targetImage[0]);
      }
    }
    setInputError({ error: errorArr, mode: mode });
  };

  const sendOtp = async () => {
    if (stamp == null || Object.keys(stamp)?.length > 0) {
      setOpenSnack({
        open: true,
        message: "Error, stamp not found",
        variant: "error",
      });
      return;
    }

    setIsLoading("STAMP");

    store
      .dispatch(getPartyContactDetails(loggedInPartyId))
      .unwrap()
      .then((resp) => {
        let partyContactMechsList = resp.data || []; // Ensure we have a valid array
        let phoneList = partyContactMechsList.filter(
          (partyContactMech: any) =>
            partyContactMech.contactmechType === "TELECOM_NUMBER"
        );

        let phone = phoneList.filter((phoneDetail: any) => {
          return phoneDetail.purposeType.includes("PRIMARY_PHONE");
        });

        if (!phone.length) {
          setOpenSnack({
            open: true,
            message: "Phone number not found.",
            variant: "error",
          });
        } else {
          let number = phone[0].detail;
          if (number.includes("+91")) {
            number = number.replace("+91", "");
            setPhone(phone[0].detail);
          } else setPhone(number);

          store
            .dispatch(
              sendOtpAPI({
                type: "phone",
                value: "+91" + number,
              })
            )
            .unwrap()
            .then((res) => {
              setShowStampSaveBtn(false);
            })
            .catch((error) => {
              setOpenSnack({
                open: true,
                message: "Unable to send OTP.",
                variant: "error",
              });

              setShowStampSaveBtn(true);
            })
            .finally(() => {
              setIsLoading("");
            });
        }
      })
      .catch(() => {
        setOpenSnack({
          open: true,
          message: "Unable to send OTP.",
          variant: "error",
        });
      });
  };

  const verifyOtp = async () => {
    setIsLoading("STAMP");

    store
      .dispatch(
        verifyOtpAPI({
          type: "phone",
          value: "+91" + phone,
          otp: otp,
        })
      )
      .unwrap()
      .then(async (res) => {
        await handleSubmitImage("STAMP");
        setShowStampSaveBtn(true);
      })
      .catch((error) => {
        setOpenSnack({
          open: true,
          message: "Invalid OTP entered. Please enter the right OTP",
          variant: "error",
        });

        setIsValidOtp(false);
      })
      .finally(() => {
        setIsLoading("");
        setOtp("");
        setIsValidOtp(true);
      });
  };

  const handleSubmitImage = async (mode: "STAMP" | "ORG_LOGO") => {
    if (mode === "STAMP") {
      if (stamp == null || Object.keys(stamp)?.length > 0) {
        setOpenSnack({
          open: true,
          message: "Error, stamp not found",
          variant: "error",
        });
        return;
      }
    }
    if (mode === "ORG_LOGO") {
      if (orgLogo == null || Object.keys(orgLogo)?.length > 0) {
        setOpenSnack({
          open: true,
          message: "Error, logo not found",
          variant: "error",
        });
        return;
      }
    }

    setIsLoading(mode);
    const formData = new FormData();
    const fileName = `${
      userContext?.orgPartyName ??
      (mode === "STAMP" ? stamp?.name : orgLogo?.name)
    }${mode === "STAMP" ? FILE_SUFFIX.STAMP : FILE_SUFFIX.ORG_LOGO}${
      mode === "STAMP"
        ? getExtensionFromMimeType(stamp?.type)
        : getExtensionFromMimeType(orgLogo?.type)
    }`;
    formData.append("file", mode === "STAMP" ? stamp : orgLogo, fileName);
    formData.append(
      "filePurposeType",
      mode === "STAMP"
        ? UPLOAD_FILE_PURPOSE_TYPE.STAMP
        : UPLOAD_FILE_PURPOSE_TYPE.ORG_LOGO
    );
    await store
      .dispatch(uploadFileParty(formData))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          setOpenSnack({
            open: true,
            message:
              "Sucessfully Uploaded " + (mode === "STAMP" ? "Stamp" : "Logo"),
            variant: "success",
          });
          const contentReqBody: createContentService = {
            contentTypeId: UPLOAD_FILE_CONTENT_TYPE.IMAGE,
            contentName:
              mode === "STAMP"
                ? UPLOAD_FILE_CONTENT_NAME.STAMP
                : UPLOAD_FILE_CONTENT_NAME.ORG_LOGO,
            description: "Organisation Logo",
            mimeTypeId: res?.data?.mime,
            objectInfo: res?.data?.path,
            purposeTypes: [
              mode === "STAMP"
                ? UPLOAD_FILE_PURPOSE_TYPE.STAMP
                : UPLOAD_FILE_PURPOSE_TYPE.ORG_LOGO,
            ],
            partyId: partyId,
          };
          store
            .dispatch(createPartyContent(contentReqBody))
            .unwrap()
            .then((res) => {
              if (res.status === 200) {
                setOpenSnack({
                  open: true,
                  message:
                    "Sucessfully Created Organisation " +
                    (mode === "STAMP" ? "Stamp" : "Logo"),
                  variant: "success",
                });
                setOrgLogo(null);
                setStamp(null);
              } else {
                setOpenSnack({
                  open: true,
                  message:
                    "Could not create Organisation " +
                    (mode === "STAMP" ? "Stamp" : "Logo"),
                  variant: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
              setOpenSnack({
                open: true,
                message: "Error in Creating Party Content",
                variant: "error",
              });
            });
        } else {
          setOpenSnack({
            open: true,
            message:
              "Error in Uploading " + (mode === "STAMP" ? "Stamp" : "Logo"),
            variant: "error",
          });
        }
      })
      .catch((error) => {
        setOpenSnack({
          open: true,
          message: "Error Uploading " + (mode === "STAMP" ? "Stamp" : "Logo"),
          variant: "error",
        });
      })
      .finally(() => {
        setIsLoading("");
      });
  };

  const turnPage = () => {
    setPageState(!pageState);
  };

  useEffect(() => {
    if (!partyId) {
      const prismUser = getSessionVariable(cookieNames.prismUser);
      if (prismUser && prismUser != "") {
        setPartyId(JSON.parse(prismUser).orgPartyIds[0]);
        setLoggedInPartyId(JSON.parse(prismUser).partyId);
      }
    } else if (pageState) {
      const dataObject: any = {
        comm: "",
        sendRFQChoice: "",
        paymentTerm: "",
        repeatValue: "",
        tnc: "",
        poSequence: {},
      };

      const existsPartyDetailsFetch = {
        [CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER]: "",
        [CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER]: "",
        [CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER]: "",
      };

      const existsComms = {
        [CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.SMS]: false,
        [CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.EMAIL]: false,
        [CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.WHATSAPP]: false,
      };

      const existBankDetails = {
        [CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_HOLDER]: "",
        [CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_NUMBER]: "",
        [CONFIGURATION_CONSTANTS.INPUT_ID.BANK_NAME]: "",
        [CONFIGURATION_CONSTANTS.INPUT_ID.IFSC_CODE]: "",
      };

      const dispatchers = async () => {
        await store
          .dispatch(getPartyById(partyId))
          .unwrap()
          .then((res) => {
            existsPartyDetailsFetch[
              CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER
            ] = res?.data?.details?.panNumber;
            existsPartyDetailsFetch[
              CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER
            ] = res?.data?.details?.gstNumber;
            existsPartyDetailsFetch[
              CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER
            ] = res?.data?.details?.tinNumber;
            setPartyIdDetails({
              ...partyIdDetails,
              [CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER]:
                existsPartyDetailsFetch?.[
                  CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER
                ],
              [CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER]:
                existsPartyDetailsFetch?.[
                  CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER
                ],
              [CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER]:
                existsPartyDetailsFetch?.[
                  CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER
                ],
            });
          })
          .catch(() => {
            handleSnack("Could Not Fetch Party", "error");
          });

        await store
          .dispatch(getPartyPref(partyId))
          .unwrap()
          .then((res) => {
            res?.data?.forEach((element: any) => {
              if (
                element.preferenceTypeId ===
                CONFIGURATION_CONSTANTS.PREFERENCE_MODES.COMMUNICATION_MODE
              ) {
                if (
                  element.prefValue ===
                  CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.SMS
                ) {
                  if (
                    !existsComms[
                      CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.SMS
                    ] &&
                    !element?.thruDate
                  ) {
                    existsComms[
                      CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.SMS
                    ] = true;
                  }
                }
                if (
                  element.prefValue ===
                  CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.EMAIL
                ) {
                  if (
                    !existsComms[
                      CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.EMAIL
                    ] &&
                    !element?.thruDate
                  ) {
                    existsComms[
                      CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.EMAIL
                    ] = true;
                  }
                }
                if (
                  element.prefValue ===
                  CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.WHATSAPP
                ) {
                  if (
                    !existsComms[
                      CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.WHATSAPP
                    ] &&
                    !element?.thruDate
                  ) {
                    existsComms[
                      CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.WHATSAPP
                    ] = true;
                  }
                }
              } else if (
                element.preferenceTypeId ===
                  CONFIGURATION_CONSTANTS.PREFERENCE_MODES.PREF_VENDORS &&
                !element?.thruDate
              ) {
                dataObject.sendRFQChoice = element.prefValue;
              } else if (
                element.preferenceTypeId ===
                  CONFIGURATION_CONSTANTS.PREFERENCE_MODES.PAYMENT_TERMS &&
                !element?.thruDate
              ) {
                dataObject.paymentTerm = element.prefValue;
              } else if (
                element.preferenceTypeId ===
                  CONFIGURATION_CONSTANTS.PREFERENCE_MODES.REPEAT_ORDER_LIMIT &&
                !element?.thruDate
              ) {
                dataObject.repeatValue = element.prefValue;
              } else if (
                element.preferenceTypeId ===
                  CONFIGURATION_CONSTANTS.PREFERENCE_MODES.PO_SEQUENCE &&
                !element?.thruDate
              ) {
                dataObject.poSequence = element.sequence;
              } else if (
                element.preferenceTypeId ===
                  CONFIGURATION_CONSTANTS.PREFERENCE_MODES.DEFAULT_TNC &&
                !element?.thruDate
              ) {
                dataObject.tnc = element.prefValue;
              } else if (
                element.preferenceTypeId ===
                  CONFIGURATION_CONSTANTS.PREFERENCE_MODES.DEFAULT_BID_DATE &&
                !element?.thruDate
              ) {
                dataObject.defaultBid = element.prefValue;
              }
            });
            setComm(
              comm.map((element) => {
                return {
                  ...element,
                  exists: existsComms[element.id],
                  checked: existsComms[element.id],
                };
              })
            );

            setSendRFQChoice(
              dataObject.sendRFQChoice.toUpperCase() === "YES"
                ? CONFIGURATION_CONSTANTS.SEND_RFQ_VALUES.PREFERRED_VENDORS
                : CONFIGURATION_CONSTANTS.SEND_RFQ_VALUES.ALL_VENDORS
            );
            setPaymentTerm(CONFIGURATION_CONSTANTS.PAYMENT_TERMS_VALUES.OTHER);
            setOtherPaymentTerm(dataObject.paymentTerm);
            setTnC(dataObject.tnc);
            setROValue(dataObject.repeatValue);
            setDefaultBid(dataObject.defaultBid);
            setSequence({
              prefix: dataObject?.poSequence?.prefix,
              startIndex: dataObject?.poSequence?.startIndex,
              currentIndex: dataObject?.poSequence?.currentIndex,
              update:
                Object.keys(dataObject?.poSequence)?.length > 0 ? true : false,
            });
            dataObject.sendRFQChoice !== ""
              ? setExistsPrefVendor(true)
              : setExistsPrefVendor(false);
            dataObject.paymentTerm !== ""
              ? setExistsPayment(true)
              : setExistsPayment(false);
            dataObject.tnc !== "" ? setExistsTnC(true) : setExistsTnC(false);
            dataObject.repeatValue
              ? setExistsROValue(true)
              : setExistsROValue(false);
          })
          .catch((err) => {
            console.log(err);
            handleSnack("Could Not Fetch Party Preferences", "error");
          });

        await store
          .dispatch(getBankDetails({}))
          .unwrap()
          .then((res) => {
            const allBankDetailsFetched = res.data;
            res.data.forEach((element: any) => {
              if (element?.status === BANK_STATUS.ACTIVE) {
                existBankDetails[
                  CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_HOLDER
                ] = element.accountHolderName;
                existBankDetails[
                  CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_NUMBER
                ] = element.accountNumber;
                existBankDetails[CONFIGURATION_CONSTANTS.INPUT_ID.BANK_NAME] =
                  element.bankName;
                existBankDetails[CONFIGURATION_CONSTANTS.INPUT_ID.IFSC_CODE] =
                  element.ifscCode;
              }
            });
            existBankDetails.accountNo !== ""
              ? setExistsBankDetails(true)
              : setExistsBankDetails(false);
            setAllBankDetails(
              allBankDetailsFetched.map((element: any) => element)
            );
            setBankDetails({ ...bankDetails, ...existBankDetails });
          })
          .catch((err) => {
            handleSnack("Could Not Fetch Bank Details", "error");
          });

        await store
          .dispatch(
            getPartyContent({
              partyId: partyId,
              orgPartyId: partyId,
              purposeType: UPLOAD_FILE_PURPOSE_TYPE.STAMP,
              status: true,
            })
          )
          .unwrap()
          .then((res) => {
            if (res.data.length > 0) {
              setStampExists(true);
            }
          })
          .catch((err: any) => {
            handleSnack("Error Fetching Organisation Stamp", "error");
          });

        await store
          .dispatch(
            getPartyContent({
              partyId: partyId,
              orgPartyId: partyId,
              purposeType: UPLOAD_FILE_PURPOSE_TYPE.ORG_LOGO,
              status: true,
            })
          )
          .unwrap()
          .then((res) => {
            if (res.data.length > 0) {
              setOrgLogoExists(true);
            }
          })
          .catch((err: any) => {
            handleSnack("Error Fetching Organisation Logo", "error");
          });

        await store
          .dispatch(getPartyTags())
          .unwrap()
          .then((res) => {
            if (res.data.partyTags.length > 0) {
              setTags(res.data.partyTags);
            }
          })
          .catch((err: any) => {
            handleSnack("Error Fetching Tags", "error");
          });
      };

      dispatchers();
    }
  }, [partyId, pageState]);

  const memoArray = [
    turnPage,
    comm,
    paymentTerm,
    sendRFQChoice,
    otherPaymentTerm,
    stamp,
    partyId,
    partyIdDetails,
    bankDetails,
    stampExists,
    roValue,
    tagInput,
    tags,
    sequence,
    loading,
    showStampSaveBtn,
    otp,
    isValidOtp
  ];

  const handleSaveBank = async () => {
    setIsLoading("BANK");
    const bankDetailsBody = {
      partyId: partyId,
      accountHolderName:
        bankDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_HOLDER],
      bankName: bankDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.BANK_NAME],
      accountNumber:
        bankDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_NUMBER],
      ifscCode: bankDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.IFSC_CODE],
    };
    if (handleErrors(bankDetailsBody, null, null, null, null, null, null)) {
      setIsLoading("");
      return;
    }
    existsBankDetails
      ? await store
          .dispatch(updateBankDetails(bankDetailsBody))
          .unwrap()
          .then(() => {
            handleSnack("Updated Bank Details", "success");
          })
          .catch(() => {
            handleSnack("Could Not Update Bank Details", "error");
          })
      : await store
          .dispatch(createBankDetails(bankDetailsBody))
          .unwrap()
          .then(() => {
            handleSnack("Created Bank Details", "success");
          })
          .catch(() => {
            handleSnack("Could Not Create Bank Details", "error");
          });
    setIsLoading("");
  };

  const handleSaveParty = async () => {
    setIsLoading("PARTY");
    const updatePartyBody = {
      partyTypeId: PARTY_TYPE.GROUP,
      gstNumber: partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER],
      tinNumber: partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER],
      panNumber: partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER],
    };
    if (handleErrors(null, updatePartyBody, null, null, null, null, null)) {
      setIsLoading("");
      return;
    }
    await store
      .dispatch(updatePartyDetails(updatePartyBody))
      .unwrap()
      .then(() => {
        handleSnack("Updated Party Details", "success");
      })
      .catch(() => {
        handleSnack("Could Not Update Party Details", "error");
      });
    setIsLoading("");
  };

  const handleSavePreferredVendors = async () => {
    setIsLoading("VENDORS");
    const partyPrefBodyVendors = {
      preferenceTypeId: CONFIGURATION_CONSTANTS.PREFERENCE_MODES.PREF_VENDORS,
      partyId: partyId,
      prefValue:
        sendRFQChoice ===
        CONFIGURATION_CONSTANTS.SEND_RFQ_VALUES.PREFERRED_VENDORS
          ? "YES"
          : "NO",
    };
    existsPrefVendor
      ? await store
          .dispatch(updatePartyPref(partyPrefBodyVendors))
          .unwrap()
          .then(() => {
            handleSnack("Updated Party Preferences: Vendors", "success");
          })
          .catch(() => {
            handleSnack("Could Not Update Party Preferences: Vendors", "error");
          })
      : await store
          .dispatch(createPartyPref(partyPrefBodyVendors))
          .unwrap()
          .then(() => {
            handleSnack("Updated Party Preferences: Vendors", "success");
          })
          .catch(() => {
            handleSnack("Could Not Update Party Preferences: Vendors", "error");
          });
    setIsLoading("");
  };

  const handleSavePayment = async () => {
    setIsLoading("PAYMENT");
    const partyPrefBodyPayment = {
      preferenceTypeId: CONFIGURATION_CONSTANTS.PREFERENCE_MODES.PAYMENT_TERMS,
      partyId: partyId,
      prefValue:
        paymentTerm === CONFIGURATION_CONSTANTS.PAYMENT_TERMS_VALUES.OTHER
          ? otherPaymentTerm.toUpperCase()
          : paymentTerm,
    };
    if (
      handleErrors(null, null, partyPrefBodyPayment, null, null, null, null)
    ) {
      setIsLoading("");
      return;
    }
    existsPayment
      ? await store
          .dispatch(updatePartyPref(partyPrefBodyPayment))
          .unwrap()
          .then(() => {
            handleSnack("Updated Party Preferences: Payment Terms", "success");
          })
          .catch(() => {
            handleSnack(
              "Could Not Update Party Preferences: Payment Terms",
              "error"
            );
          })
      : await store
          .dispatch(createPartyPref(partyPrefBodyPayment))
          .unwrap()
          .then(() => {
            handleSnack("Updated Party Preferences: Payment Terms", "success");
          })
          .catch(() => {
            handleSnack(
              "Could Not Update Party Preferences: Payment Terms",
              "error"
            );
          });
    setIsLoading("");
  };

  const handleSaveTerms = async () => {
    setIsLoading("TERMS");
    const partyPrefBodyTerms = {
      preferenceTypeId: CONFIGURATION_CONSTANTS.PREFERENCE_MODES.DEFAULT_TNC,
      partyId: partyId,
      prefValue: tnc,
    };
    if (handleErrors(null, null, null, null, null, partyPrefBodyTerms, null)) {
      setIsLoading("");
      return;
    }
    existsPayment
      ? await store
          .dispatch(updatePartyPref(partyPrefBodyTerms))
          .unwrap()
          .then(() => {
            handleSnack(
              "Updated Party Preferences: Terms and Conditions",
              "success"
            );
          })
          .catch(() => {
            handleSnack(
              "Could Not Update Party Preferences:  Terms and Conditions",
              "error"
            );
          })
      : await store
          .dispatch(createPartyPref(partyPrefBodyTerms))
          .unwrap()
          .then(() => {
            handleSnack(
              "Updated Party Preferences: Terms and Conditions",
              "success"
            );
          })
          .catch(() => {
            handleSnack(
              "Could Not Update Party Preferences: Terms and Conditions",
              "error"
            );
          });
    setIsLoading("");
  };

  const handleSaveRO = async () => {
    setIsLoading("RO");
    const partyPrefBodyRO = {
      preferenceTypeId:
        CONFIGURATION_CONSTANTS.PREFERENCE_MODES.REPEAT_ORDER_LIMIT,
      partyId: partyId,
      prefValue: roValue,
    };
    if (handleErrors(null, null, null, partyPrefBodyRO, null, null, null)) {
      setIsLoading("");
      return;
    }
    existsROValue
      ? await store
          .dispatch(updatePartyPref(partyPrefBodyRO))
          .unwrap()
          .then(() => {
            handleSnack("Updated Party Preferences: RO Value", "success");
          })
          .catch(() => {
            handleSnack(
              "Could Not Update Party Preferences: RO Value",
              "error"
            );
          })
      : await store
          .dispatch(createPartyPref(partyPrefBodyRO))
          .unwrap()
          .then(() => {
            handleSnack("Updated Party Preferences: RO Value", "success");
          })
          .catch(() => {
            handleSnack(
              "Could Not Update Party Preferences: RO Value",
              "error"
            );
          });
    setIsLoading("");
  };

  const handleSaveDefaultBid = async () => {
    setIsLoading("BID");
    const partyPrefBodyBid = {
      preferenceTypeId:
        CONFIGURATION_CONSTANTS.PREFERENCE_MODES.DEFAULT_BID_DATE,
      partyId: partyId,
      prefValue: defaultBid?.toString(),
    };
    if (handleErrors(null, null, null, null, null, null, partyPrefBodyBid)) {
      setIsLoading("");
      return;
    }
    existsROValue
      ? await store
          .dispatch(updatePartyPref(partyPrefBodyBid))
          .unwrap()
          .then(() => {
            handleSnack(
              "Updated Party Preferences: Default Bid End Date",
              "success"
            );
          })
          .catch(() => {
            handleSnack(
              "Could Not Update Party Preferences: Default Bid End Date",
              "error"
            );
          })
      : await store
          .dispatch(createPartyPref(partyPrefBodyBid))
          .unwrap()
          .then(() => {
            handleSnack(
              "Updated Party Preferences: Default Bid End Date",
              "success"
            );
          })
          .catch(() => {
            handleSnack(
              "Could Not Update Party Preferences: Default Bid End Date",
              "error"
            );
          });
    setIsLoading("");
  };

  const handleSaveComm = async () => {
    setIsLoading("COMMUNICATION");
    const partyPrefBodyCommSMS = {
      preferenceTypeId:
        CONFIGURATION_CONSTANTS.PREFERENCE_MODES.COMMUNICATION_MODE,
      partyId: partyId,
      prefValue: CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.SMS,
      isEnabled: comm[2].checked,
    };
    const partyPrefBodyCommWhatsapp = {
      preferenceTypeId:
        CONFIGURATION_CONSTANTS.PREFERENCE_MODES.COMMUNICATION_MODE,
      partyId: partyId,
      prefValue: CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.WHATSAPP,
      isEnabled: comm[1].checked,
    };
    const partyPrefBodyCommEmail = {
      preferenceTypeId:
        CONFIGURATION_CONSTANTS.PREFERENCE_MODES.COMMUNICATION_MODE,
      partyId: partyId,
      prefValue: CONFIGURATION_CONSTANTS.COMMUNICATION_MODE_VALUES.EMAIL,
      isEnabled: comm[0].checked,
    };
    await store
      .dispatch(updatePartyPref(partyPrefBodyCommEmail))
      .unwrap()
      .then(() => {
        handleSnack("Updated Party Preferences: Email", "success");
      })
      .catch(() => {
        handleSnack("Could Not Update Party Preferences: Email", "error");
      });

    await store
      .dispatch(updatePartyPref(partyPrefBodyCommSMS))
      .unwrap()
      .then(() => {
        handleSnack("Updated Party Preferences: SMS", "success");
      })
      .catch(() => {
        handleSnack("Could Not Update Party Preferences: SMS", "error");
      });

    await store
      .dispatch(updatePartyPref(partyPrefBodyCommWhatsapp))
      .unwrap()
      .then(() => {
        handleSnack("Updated Party Preferences: Whatsapp", "success");
      })
      .catch(() => {
        handleSnack("Could Not Update Party Preferences: Whatsapp", "error");
      });
    setIsLoading("");
  };

  const handleAddTag = async () => {
    setIsLoading("TAGS");
    if (!tagInput.trim()) {
      handleSnack("Empty tags cannot be created", "error");
      setIsLoading("");
      return;
    }

    await store
      .dispatch(
        createPartyTags({
          tags: [tagInput],
        })
      )
      .unwrap()
      .then((res) => {
        handleSnack("Tag successfully added", "success");

        setTags(res.data.partyTags);
        setTagInput("");
      })
      .catch(() => {
        handleSnack("Could not add the tag", "error");
      });
    setIsLoading("");
  };

  const deactivateTagById = async (tagId: string) => {
    setIsLoading("TAGS");
    await store
      .dispatch(deactivateTag(tagId))
      .unwrap()
      .then((res) => {
        handleSnack("Tag successfully deactivated", "success");

        setTags((prev: any) => {
          return prev.filter((tag: any) => {
            return tag._id !== tagId;
          });
        });
      })
      .catch(() => {
        handleSnack("Could not deactivate the tag", "error");
      });
    setIsLoading("");
  };

  const disablePOSequence = async () => {
    setIsLoading("PO_SEQUENCE");
    const partyPOPrefBody = {
      partyId: partyId,
      prefValue: sequence.prefix,
      preferenceTypeId: CONFIGURATION_CONSTANTS.PREFERENCE_MODES.PO_SEQUENCE,
      sequence: {
        prefix: sequence.prefix,
        startIndex: sequence.startIndex,
        currentIndex: sequence.currentIndex,
        lastModifiedIndex: sequence.currentIndex,
      },
      isEnabled: false,
    };

    await store
      .dispatch(updatePartyPref(partyPOPrefBody))
      .unwrap()
      .then(() => {
        handleSnack(
          "Updated Party Preferences: Purchase Order Sequence",
          "success"
        );
        setSequence({
          prefix: "",
          startIndex: "",
          currentIndex: "",
          update: false,
        });
      })
      .catch(() => {
        handleSnack(
          "Could Not Update Party Preferences: Purchase Order Sequence",
          "error"
        );
      });
  };

  const handleSubmitPOSequencePreference = async () => {
    setIsLoading("PO_SEQUENCE");
    const partyPOPrefBody = {
      partyId: partyId,
      prefValue: sequence.prefix,
      preferenceTypeId: CONFIGURATION_CONSTANTS.PREFERENCE_MODES.PO_SEQUENCE,
      sequence: {
        prefix: sequence.prefix,
        startIndex: sequence.startIndex,
        currentIndex: sequence.currentIndex,
        lastModifiedIndex: sequence.currentIndex,
      },
      isEnabled: true,
    };
    if (handleErrors(null, null, null, null, partyPOPrefBody, null, null)) {
      setIsLoading("");
      return;
    }
    sequence.update
      ? await store
          .dispatch(updatePartyPref(partyPOPrefBody))
          .unwrap()
          .then(() => {
            handleSnack(
              "Updated Party Preferences: Purchase Order Sequence",
              "success"
            );
          })
          .catch(() => {
            handleSnack(
              "Could Not Update Party Preferences: Purchase Order Sequence",
              "error"
            );
          })
      : await store
          .dispatch(createPartyPref(partyPOPrefBody))
          .unwrap()
          .then(() => {
            handleSnack(
              "Created Party Preferences: Purchase Order Sequence",
              "success"
            );
          })
          .catch(() => {
            handleSnack(
              "Could Not Create Party Preferences: Purchase Order Sequence",
              "error"
            );
          });
    setIsLoading("");
  };

  const handleErrors = (
    bankDetailsBody: any,
    updatePartyBody: any,
    partyPrefBodyPayment: any,
    partyPrefBodyRO: any,
    partyPOPrefBody: any,
    partyPrefBodyTerms: any,
    partyPrefBodyBid: any
  ) => {
    const errorObj = {
      [CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_HOLDER]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_NUMBER]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.BANK_NAME]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.IFSC_CODE]: "",
      otherPaymentTerm: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.REPEAT_ORDER]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.TAGS]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.PO_CURRENT]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.PO_PREFIX]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.PO_START]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.TnC]: "",
      [CONFIGURATION_CONSTANTS.INPUT_ID.DEFAULT_BID_DATE]: "",
    };

    const errorItems = validateConfiguration(
      bankDetailsBody,
      updatePartyBody,
      partyPrefBodyPayment,
      partyPrefBodyRO,
      partyPOPrefBody,
      partyPrefBodyTerms,
      partyPrefBodyBid
    );
    if (errorItems.length > 0) {
      errorItems.forEach((element) => {
        errorObj[element.elementId] = element.message;
      });
      setErrorItems({ ...errorObj });
      return true;
    }
    setErrorItems({ ...errorObj });
    return false;
  };

  const elEdit = useMemo(() => {
    return (
      <Card sx={{ p: { xs: 2, md: 4 }, borderRadius: 2, boxShadow: "none", border: "1px solid #DDDDDD" }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Button
            onClick={turnPage}
            sx={{ color: "primary.main", textTransform: "none", fontWeight: 500 }}
            disabled={loading !== ""}
            startIcon={<KeyboardBackspaceIcon />}
          >
            Back to View Configuration
          </Button>
        </Box>

        <Stack gap={3}>
          <Box>
            <Typography variant="subtitle1" fontWeight={500} color="text.secondary" mb={1}>
              {CONFIGURATION_CONSTANTS?.PAYMENT_TERM}
            </Typography>
            <Collapse
              in={paymentTerm === CONFIGURATION_CONSTANTS.PAYMENT_TERMS_VALUES.OTHER}
            >
              <FormControl fullWidth sx={{ maxWidth: { xs: "100%", md: "50%" }, mb: 2 }}>
                <TextField
                  id={CONFIGURATION_CONSTANTS.INPUT_ID.O_PAYMENT_TERM}
                  variant="filled"
                  multiline
                  rows={3}
                  error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.O_PAYMENT_TERM] !== ""}
                  helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.O_PAYMENT_TERM]}
                  value={otherPaymentTerm}
                  onChange={(e) =>
                    setOtherPaymentTerm(e.target.value.replace(/[^\x20-\x7E\n]/g, " "))
                  }
                />
              </FormControl>
            </Collapse>
            <Box>
              {loading === "PAYMENT" ? (
                <CustomSpinner />
              ) : (
                <Button variant="outlined" onClick={handleSavePayment} sx={{ textTransform: "none" }}>
                  Save Payment Terms
                </Button>
              )}
            </Box>
          </Box>
          
          <Divider />

          <Box>
            <Typography variant="subtitle1" fontWeight={500} color="text.secondary" mb={1}>
              {CONFIGURATION_CONSTANTS?.TnC}
            </Typography>
            <FormControl fullWidth sx={{ maxWidth: { xs: "100%", md: "95%" }, mb: 2 }}>
              <TextField
                id={CONFIGURATION_CONSTANTS.INPUT_ID.TnC}
                variant="filled"
                multiline
                rows={10}
                error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.TnC] !== ""}
                helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.TnC]}
                value={tnc}
                onChange={(e) => setTnC(e.target.value.replace(/[^\x20-\x7E\n]/g, " "))}
              />
            </FormControl>
            <Box>
              {loading === "TERMS" ? (
                <CustomSpinner />
              ) : (
                <Button variant="outlined" onClick={handleSaveTerms} sx={{ textTransform: "none" }}>
                  Save Terms and Conditions
                </Button>
              )}
            </Box>
          </Box>
          
          <Divider />

          <Box>
            <Typography variant="subtitle1" fontWeight={500} color="text.secondary">
              {CONFIGURATION_CONSTANTS?.STAMP}
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={1}>
              ( Acceptable Types: image, Maximum Size: 5 MB )
            </Typography>
            
            <Box
              sx={{
                width: 1,
                borderRadius: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f6f6f6",
                p: { xs: 2, sm: 3 },
                mb: 2,
                position: "relative",
                cursor: "pointer",
                border: "1px dashed #E6E6E6",
                transition: "0.2s",
                "&:hover": { borderColor: "primary.main" }
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  color: stamp && stamp?.name ? "text.primary" : "text.secondary",
                  fontWeight: 500,
                }}
              >
                {stamp && stamp?.name ? stamp?.name : "Choose file"}
              </Typography>
              <Button sx={{ textTransform: "none", color: "primary.main" }} startIcon={<CreateNewFolder />}>
                Upload file
              </Button>
              <Input
                type="file"
                inputProps={{ accept: "image/*" }}
                onChange={(event) => {
                  if (event?.target instanceof HTMLInputElement) {
                    handleImageChange(event?.target?.files, "STAMP");
                  }
                }}
                sx={{
                  width: 1,
                  height: 1,
                  opacity: 0,
                  border: "none",
                  position: "absolute",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  cursor: "pointer",
                }}
              />
            </Box>

            {inputError?.mode === "STAMP" && inputError?.error?.length > 0 && (
              <Stack gap={1} mb={2}>
                {inputError?.error?.map((element, index) => (
                  <Typography variant="body2" color="error.main" key={index}>
                    {element}
                  </Typography>
                ))}
              </Stack>
            )}

            {showStampSaveBtn ? (
              <Box>
                {loading === "STAMP" ? (
                  <CustomSpinner />
                ) : (
                  <Button variant="outlined" onClick={() => sendOtp()} sx={{ textTransform: "none" }}>
                    Save Stamp
                  </Button>
                )}
              </Box>
            ) : (
              <Box sx={{ mt: 2 }}>
                <Typography mb={2}>
                  Please enter the OTP sent to your registered mobile number
                </Typography>
                <Box mb={2}>
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    shouldAutoFocus={true}
                    renderSeparator={<span style={{ width: "27px" }}></span>}
                    renderInput={(props) => <input {...props} inputMode="numeric" />}
                    inputStyle={{
                      width: "53px",
                      height: "58px",
                      border: "1px solid #E6E6E6",
                      fontSize: "16px",
                      borderRadius: "8px",
                      borderBottomColor: `${!isValidOtp ? "#CD020C" : "#E6E6E6"}`,
                    }}
                  />
                </Box>
                {loading === "STAMP" ? (
                  <CustomSpinner />
                ) : (
                  <Button variant="outlined" onClick={verifyOtp} sx={{ textTransform: "none" }}>
                    Verify OTP
                  </Button>
                )}
              </Box>
            )}
          </Box>
          
          <Divider />

          <Box>
            <Typography variant="subtitle1" fontWeight={500} color="text.secondary">
              {CONFIGURATION_CONSTANTS?.ORGLOGO}
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={1}>
              ( Acceptable Types: image, Maximum Size: 5 MB )
            </Typography>

            <Box
              sx={{
                width: 1,
                borderRadius: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f6f6f6",
                p: { xs: 2, sm: 3 },
                mb: 2,
                position: "relative",
                cursor: "pointer",
                border: "1px dashed #E6E6E6",
                transition: "0.2s",
                "&:hover": { borderColor: "primary.main" }
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  color: orgLogo && orgLogo?.name ? "text.primary" : "text.secondary",
                  fontWeight: 500,
                }}
              >
                {orgLogo && orgLogo?.name ? orgLogo?.name : "Choose file"}
              </Typography>
              <Button sx={{ textTransform: "none", color: "primary.main" }} startIcon={<CreateNewFolder />}>
                Upload file
              </Button>
              <Input
                type="file"
                inputProps={{ accept: "image/*" }}
                onChange={(event) => {
                  if (event?.target instanceof HTMLInputElement) {
                    handleImageChange(event?.target?.files, "ORG_LOGO");
                  }
                }}
                sx={{
                  width: 1,
                  height: 1,
                  opacity: 0,
                  border: "none",
                  position: "absolute",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  cursor: "pointer",
                }}
              />
            </Box>

            {inputError?.mode === "ORG_LOGO" && inputError?.error?.length > 0 && (
              <Stack gap={1} mb={2}>
                {inputError?.error?.map((element, index) => (
                  <Typography variant="body2" color="error.main" key={index}>
                    {element}
                  </Typography>
                ))}
              </Stack>
            )}

            <Box>
              {loading === "ORG_LOGO" ? (
                <CustomSpinner />
              ) : (
                <Button variant="outlined" onClick={() => handleSubmitImage("ORG_LOGO")} sx={{ textTransform: "none" }}>
                  Save Org Logo
                </Button>
              )}
            </Box>
          </Box>
          
          <Divider />

          <Box>
            <Typography variant="h6" fontWeight={600} mb={2}>
              {CONFIGURATION_CONSTANTS?.REPEAT_ORDER}
            </Typography>
            <FormControl fullWidth sx={{ maxWidth: { xs: "100%", md: "50%" }, mb: 2 }}>
              <TextField
                id={CONFIGURATION_CONSTANTS.INPUT_ID.REPEAT_ORDER}
                label="Repeat Order Limit"
                value={roValue}
                error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.REPEAT_ORDER] !== ""}
                helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.REPEAT_ORDER]}
                onChange={(e) => handleChangeROValue(e)}
              />
            </FormControl>
            <Box>
              {loading === "RO" ? (
                <CustomSpinner />
              ) : (
                <Button variant="outlined" onClick={handleSaveRO} sx={{ textTransform: "none" }}>
                  Save RO Value
                </Button>
              )}
            </Box>
          </Box>
          
          <Divider />

          <Box>
            <Typography variant="h6" fontWeight={600} mb={2}>
              Organization Details
            </Typography>
            <Stack gap={2}>
              {storeParentPartyOrg === "" && (
                <FormControl fullWidth sx={{ maxWidth: { xs: "100%", md: "50%" } }}>
                  <Typography variant="subtitle2" color="text.secondary" mb={0.5}>
                    {CONFIGURATION_CONSTANTS?.GST_NUMBER}
                  </Typography>
                  <TextField
                    id={CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER}
                    placeholder="GST Number"
                    value={partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER]}
                    error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER] !== ""}
                    helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER]}
                    onChange={(e) => handleChangePartyDetails(e)}
                  />
                </FormControl>
              )}
              
              <Stack direction={{ xs: "column", sm: "row" }} gap={2} sx={{ maxWidth: { xs: "100%", md: "50%" } }}>
                <FormControl fullWidth>
                  <Typography variant="subtitle2" color="text.secondary" mb={0.5}>
                    {CONFIGURATION_CONSTANTS?.PAN_NUMBER}
                  </Typography>
                  <TextField
                    id={CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER}
                    placeholder="PAN Number"
                    value={partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER]}
                    error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER] !== ""}
                    helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER]}
                    onChange={(e) => handleChangePartyDetails(e)}
                  />
                </FormControl>
                
                <FormControl fullWidth>
                  <Typography variant="subtitle2" color="text.secondary" mb={0.5}>
                    {CONFIGURATION_CONSTANTS?.TIN_NUMBER}
                  </Typography>
                  <TextField
                    id={CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER}
                    placeholder="TIN Number"
                    value={partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER]}
                    error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER] !== ""}
                    helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER]}
                    onChange={(e) => handleChangePartyDetails(e)}
                  />
                </FormControl>
              </Stack>
              
              <Box mt={1}>
                {loading === "PARTY" ? (
                  <CustomSpinner />
                ) : (
                  <Button variant="outlined" onClick={handleSaveParty} sx={{ textTransform: "none" }}>
                    Save Organization Details
                  </Button>
                )}
              </Box>
            </Stack>
          </Box>
          
          <Divider />

          <Box>
            <Typography variant="h6" fontWeight={600} mb={2}>
              {CONFIGURATION_CONSTANTS?.TAGS}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" mb={2}>
              Pre-defined tags
            </Typography>

            <Stack direction={{ xs: "column", sm: "row" }} gap={2} mb={3}>
              <FormControl fullWidth sx={{ maxWidth: { xs: "100%", sm: "70%" } }}>
                <TextField
                  id={CONFIGURATION_CONSTANTS.INPUT_ID.TAGS}
                  value={tagInput}
                  error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.TAGS] !== ""}
                  helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.TAGS]}
                  placeholder="Add tags"
                  onChange={(e) => setTagInput(e.target.value)}
                  inputProps={{ maxLength: 50 }}
                  sx={{ backgroundColor: "#F6F6F6" }}
                />
              </FormControl>
              <Button
                variant="contained"
                onClick={() => handleAddTag()}
                sx={{ minWidth: "150px", textTransform: "none" }}
              >
                Add tag
              </Button>
            </Stack>

            <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap", mb: 2 }}>
              {tags
                .sort((x: any, y: any) => (x.active === y.active ? 0 : x.active ? -1 : 1))
                .map((tag: any, index: number) => (
                  <Chip
                    key={tag._id || index}
                    label={`${tag.tagName} ${tag.active ? " ✕" : ""}`}
                    variant={tag.active ? "outlined" : "filled"}
                    color={tag.active ? "primary" : "default"}
                    onClick={tag.active ? () => deactivateTagById(tag._id) : undefined}
                    sx={{
                      borderRadius: "25px",
                      cursor: tag.active ? "pointer" : "not-allowed",
                      px: 1,
                      ...(tag.active ? { borderColor: "primary.main", color: "primary.main" } : {})
                    }}
                  />
                ))}
            </Box>
          </Box>
          
          <Divider />

          <Box>
            <Typography variant="h6" fontWeight={600} mb={2}>
              {CONFIGURATION_CONSTANTS?.COMMUNICATION}
            </Typography>
            <FormGroup sx={{ mb: 2 }}>
              <Stack direction="row" flexWrap="wrap" gap={3}>
                {comm?.map((element) => (
                  <FormControlLabel
                    key={element.id}
                    control={
                      <Checkbox
                        checked={element.checked}
                        onChange={() => handleComm(element.id)}
                        sx={{ color: "primary.main", "&.Mui-checked": { color: "primary.main" } }}
                      />
                    }
                    label={element.name}
                  />
                ))}
              </Stack>
            </FormGroup>
            <Box>
              {loading === "COMMUNICATION" ? (
                <CustomSpinner />
              ) : (
                <Button variant="outlined" onClick={handleSaveComm} sx={{ textTransform: "none" }}>
                  Save Communication Preference
                </Button>
              )}
            </Box>
          </Box>
          
          <Divider />

          <Box>
            <Typography variant="h6" fontWeight={600} mb={2}>
              {CONFIGURATION_CONSTANTS?.PO_SEQUENCE?.SEQUENCE}
            </Typography>
            <Stack gap={2}>
              <FormControl fullWidth sx={{ maxWidth: { xs: "100%", md: "50%" } }}>
                <TextField
                  id={CONFIGURATION_CONSTANTS.INPUT_ID.PO_PREFIX}
                  label="Sequence Prefix"
                  value={sequence.prefix}
                  error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.PO_PREFIX] !== ""}
                  helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.PO_PREFIX]}
                  onChange={(e) => setSequence({ ...sequence, prefix: e.target.value })}
                />
              </FormControl>

              <Stack direction={{ xs: "column", sm: "row" }} gap={2} sx={{ maxWidth: { xs: "100%", md: "50%" } }}>
                <FormControl fullWidth>
                  <TextField
                    id={CONFIGURATION_CONSTANTS.INPUT_ID.PO_START}
                    label="Start Index"
                    value={sequence.startIndex}
                    error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.PO_START] !== ""}
                    helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.PO_START]}
                    onChange={(e) => {
                      if (parseInt(e.target.value) > parseInt(sequence.currentIndex)) {
                        setSequence({ ...sequence, startIndex: e.target.value, currentIndex: e.target.value });
                      } else {
                        setSequence({ ...sequence, startIndex: e.target.value });
                      }
                    }}
                  />
                </FormControl>
                
                <FormControl fullWidth>
                  <TextField
                    id={CONFIGURATION_CONSTANTS.INPUT_ID.PO_CURRENT}
                    label="Current Index"
                    value={sequence.currentIndex}
                    error={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.PO_CURRENT] !== ""}
                    helperText={errorItems[CONFIGURATION_CONSTANTS.INPUT_ID.PO_CURRENT]}
                    onChange={(e) => setSequence({ ...sequence, currentIndex: e.target.value })}
                  />
                </FormControl>
              </Stack>
              
              <Box mt={1}>
                {loading === "PO_SEQUENCE" ? (
                  <CustomSpinner />
                ) : (
                  <Button variant="outlined" onClick={handleSubmitPOSequencePreference} sx={{ textTransform: "none" }}>
                    Save PO Series
                  </Button>
                )}
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Card>
    );
  }, memoArray);

  const elSave = useMemo(() => {
    return (
      <Card sx={{ borderRadius: 2, boxShadow: "none", border: "1px solid #DDDDDD", flex: 1 }}>
        <Box>
          <Box
            sx={{
              backgroundColor: "#F7F7F7",
              py: 1.5,
              px: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #DDDDDD",
            }}
          >
            <Typography variant="body1" fontWeight={500}>
              Configuration
            </Typography>
            <Button
              startIcon={<AppRegistrationIcon />}
              variant="text"
              sx={{ color: "primary.main", textTransform: "none" }}
              onClick={turnPage}
            >
              Edit
            </Button>
          </Box>

          <Grid container spacing={3} sx={{ p: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary" mb={0.5}>
                {CONFIGURATION_CONSTANTS?.PAYMENT_TERM}
              </Typography>
              <Typography variant="body1" fontWeight={500} color="text.primary">
                {paymentTerm === ""
                  ? "Not Set"
                  : paymentTerm === CONFIGURATION_CONSTANTS.PAYMENT_TERMS_VALUES.OTHER
                  ? otherPaymentTerm
                  : paymentTerm}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary" mb={0.5}>
                {CONFIGURATION_CONSTANTS?.COMMUNICATION}
              </Typography>
              <Stack direction="row" flexWrap="wrap" divider={<Typography variant="body1" mx={0.5}>/</Typography>}>
                {comm.map((element) => {
                  if (element.checked) {
                    return (
                      <Typography variant="body1" fontWeight={500} key={element.id}>
                        {element.name}
                      </Typography>
                    );
                  }
                })}
              </Stack>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary" mb={1}>
                {CONFIGURATION_CONSTANTS?.STAMP}
              </Typography>
              <Chip
                label={stampExists ? "Uploaded" : "Not Set"}
                color={stampExists ? "success" : "error"}
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
          </Grid>

          <Divider />

          <Grid container spacing={3} sx={{ p: 3 }}>
            {storeParentPartyOrg === "" && (
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="body2" color="text.secondary" mb={0.5}>
                  {CONFIGURATION_CONSTANTS?.GST_NUMBER}
                </Typography>
                <Typography variant="body1" fontWeight={500} color="text.primary">
                  {partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER] === ""
                    ? "Not Set"
                    : partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER]}
                </Typography>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary" mb={0.5}>
                {CONFIGURATION_CONSTANTS?.TIN_NUMBER}
              </Typography>
              <Typography variant="body1" fontWeight={500} color="text.primary">
                {partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER] === ""
                  ? "Not Set"
                  : partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER]}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary" mb={0.5}>
                {CONFIGURATION_CONSTANTS?.PAN_NUMBER}
              </Typography>
              <Typography variant="body1" fontWeight={500} color="text.primary">
                {partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER] === ""
                  ? "Not Set"
                  : partyIdDetails?.[CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER]}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary" mb={1}>
                {CONFIGURATION_CONSTANTS?.ORGLOGO}
              </Typography>
              <Chip
                label={orgLogoExists ? "Uploaded" : "Not Set"}
                color={orgLogoExists ? "success" : "error"}
                size="small"
                sx={{ borderRadius: 1 }}
              />
            </Grid>
          </Grid>

          <Divider />

          <Grid container spacing={3} sx={{ p: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary" mb={0.5}>
                {CONFIGURATION_CONSTANTS?.REPEAT_ORDER}
              </Typography>
              <Typography variant="body1" fontWeight={500} color="text.primary">
                {!roValue
                  ? "Not Set"
                  : Number(roValue)?.toLocaleString("en-IN", {
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "INR",
                    })}
              </Typography>
            </Grid>
          </Grid>

          <Divider />

          <Grid container spacing={3} sx={{ p: 3 }}>
            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary" mb={0.5}>
                {CONFIGURATION_CONSTANTS?.TnC}
              </Typography>
              <Typography variant="body1" fontWeight={500} color="text.primary" sx={{ whiteSpace: "pre-line" }}>
                {!tnc ? "Not Set" : tnc}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mt: 2, borderTop: "1px solid #DDDDDD" }}>
          <Box
            sx={{
              backgroundColor: "#F7F7F7",
              py: 1.5,
              px: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #DDDDDD",
            }}
          >
            <Typography variant="body1" fontWeight={500}>
              Order Series Configuration
            </Typography>
            <Stack direction="row" spacing={1}>
              <Button
                startIcon={<AppRegistrationIcon />}
                variant="text"
                sx={{ color: "primary.main", textTransform: "none" }}
                onClick={turnPage}
              >
                Edit
              </Button>
              <Button
                startIcon={<Delete />}
                variant="text"
                color="error"
                sx={{ textTransform: "none" }}
                onClick={disablePOSequence}
              >
                Disable
              </Button>
            </Stack>
          </Box>

          <Grid container spacing={3} sx={{ p: 3 }}>
            <Grid item xs={12} sm={4}>
              <Typography variant="body2" color="text.secondary" mb={0.5}>
                Prefix
              </Typography>
              <Typography variant="body1" fontWeight={500} color="text.primary">
                {!sequence.prefix ? "Not Set" : sequence.prefix}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography variant="body2" color="text.secondary" mb={0.5}>
                Current Index
              </Typography>
              <Typography variant="body1" fontWeight={500} color="text.primary">
                {!sequence.currentIndex ? "Not Set" : sequence.currentIndex}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Typography variant="body2" color="text.secondary" mb={0.5}>
                Start Index
              </Typography>
              <Typography variant="body1" fontWeight={500} color="text.primary">
                {!sequence.startIndex ? "Not Set" : sequence.startIndex}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Card>
    );
  }, memoArray);

  return (
    <Box>
      <Snackbar
        open={openSnack.open}
        autoHideDuration={6000}
        onClose={handleCloseSnack}
      >
        {openSnack.variant === "success" ? (
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {openSnack.message}
          </Alert>
        ) : (
          <Alert
            onClose={handleCloseSnack}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {openSnack.message}
          </Alert>
        )}
      </Snackbar>
      <Box>{pageState ? elSave : elEdit}</Box>
    </Box>
  );
};

export default Configuration;